import React from 'react';
import { MapPin } from 'lucide-react';
interface CityChipProps {
  city: string;
}
export function CityChip({
  city
}: CityChipProps) {
  return <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-50 text-primary border border-blue-100 hover:bg-blue-100 transition-colors cursor-default" data-id="element-295">
      <MapPin className="w-4 h-4 mr-2" data-id="element-296" />
      <span className="font-medium" data-id="element-297">{city}</span>
    </div>;
}